module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "convenience",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "convenience"
    }
  }, [_c('h3', [_vm._v("Location convenience in " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.walkscore.com/"
    }
  }, [_vm._v("Walkscore.com")]), _vm._v(" has compiled scores showing how easy it is to walk, bike, or take public transit in each neighborhood.\n  "), _c('div', {
    staticStyle: {
      "min-width": "960px",
      "max-width": "960px",
      "height": "400px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "walkscoreChart"
    }
  }), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57e18562!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Convenience.vue
// module id = 178
// module chunks = 1